import uniqueId from "lodash/uniqueId";

import type { Contact } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

export const parseContactString = (value: string): Pick<Contact, "name" | "title"> => {
    const index = value.search(/,/);
    return {
        name: index !== -1 ? value.slice(0, index).trim() : value.trim(),
        title: index !== -1 ? value.slice(index + 1).trim() : "",
    };
};

export const stringifyContact = (contacts: Contact): string =>
    contacts.title ? `${contacts.name}, ${contacts.title}` : (contacts.name ?? "");

export const createNewContact = ({
    name,
    title,
    source,
    id,
    isFromContactsList,
}: Pick<Contact, "name" | "title" | "source" | "id" | "isFromContactsList">): Contact => ({
    name: name ?? "",
    title: title ?? "",
    isSelected: true,
    id: id ?? uniqueId(),
    source,
    isFromContactsList,
});

export const countSelectedContacts = (contacts: Contact[]): number =>
    contacts.filter((contact) => contact.isSelected).length;
